export default "__VITE_ASSET__Cf6Nv3Fu__"